module.exports = __webpack_public_path__ + "static/media/hero.9c7485f2.jpg";